import { Container } from './styles'

import reactIcon from '../../assets/react-icon.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="#" className="logo">
        <span>SH.</span>
        <span>Azizxon</span>
      </a>
      <div>
        <p>
        This site is created by <a href="http://t.me/sulaymanov_a" style={{color: 'var(--green)', textDecoration:"underline"}} target="_blank" rel="noopener noreferrer">Ahror</a>
        </p>
      </div>

    </Container>
  )
}
